<template>
  <b-container>
    <b-row class="m-3 p-3" v-if="$route.params.msg">
        <b-col>
          <b-alert
            :show="dismissCountDown"
            variant="success"
            class="text-center"
            @dismissed="dismissCountDown=0"
          >{{ $route.params.msg }}</b-alert>
        </b-col>
      </b-row>
    <b-jumbotron v-if="!isUserLoggedIn" bg-variant="light">
      <div v-show="pageError.received">
        <h3>{{pageError.msg}}</h3>
        <hr class="my-4">
        <p>{{ $t('ChangePassword.ifNotLoggedIn') }}</p>
      </div>
    </b-jumbotron>
    <b-card border-variant="danger" :header="$t('ChangePassword.header')" header-bg-variant="danger" header-text-variant="white" align="left">
      <b-form @submit="onSubmit" autocomplete="off">
        <b-row class="my-1">
          <b-col>
            <b-form-input :placeholder="$t('ChangePassword.currentPasswordPlaceholder')" type="password"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col>
            <b-form-input :placeholder="$t('ChangePassword.newPasswordPlaceholder')" type="password"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col>
            <b-form-input :placeholder="$t('ChangePassword.confirmNewPasswordPlaceholder')" type="password"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-button variant="danger" type="submit">{{ $t('ChangePassword.changePasswordButton') }}</b-button>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-alert :show="formError.received" variant="danger" class="text-center">{{formError.msg}}</b-alert>
        </b-row>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
/* CONTROLLER */
import AuthenticationService from '@/services/AuthenticationService'
import { mapGetters } from 'vuex'

export default {
  name: 'ChangePassword',
  data () {
    return {
      formError: {
        received: false,
        msg: ''
      },
      pageError: {
        received: false,
        msg: ''
      },
      dismissCountDown: 30
    }
  },
  mounted () {
    // if not logged in, redirect to home page
    this.redirect()
  },
  methods: {
    onSubmit (e) {
      e.preventDefault()
      this.changePassword()
    },
    async changePassword () {
      // clear out success alert in case it already exists
      this.regSuccesful = false

      try {
        const response = await AuthenticationService.changePassword({
          _id: this.user._id,
          currentPassword: document.querySelectorAll('input[type="password"]')[0].value,
          newPassword: document.querySelectorAll('input[type="password"]')[1].value,
          newPasswordConf: document.querySelectorAll('input[type="password"]')[2].value,
          resetPassword: false
        })
        // set store state for user
        this.$store.dispatch('setUser', response.data.user)

        // redirect to home page, and send welcome message
        this.$router.push({
          name: 'Home',
          params: { msg: this.$i18n.t('ChangePassword.passwordChangedMsg') }
        })
      } catch (error) {
        this.formError.received = true
        if (error.response.data.error === 'userNotFound') {
          this.formError.msg = this.$i18n.t('ChangePassword.serverMessages.userNotFound')
        } else if (error.response.data.error === 'incorrectPassword') {
          this.formError.msg = this.$i18n.t('ChangePassword.serverMessages.incorrectPassword')
        } else {
          this.formError.msg = this.$i18n.t('ChangePassword.serverMessages.generic')
        }
      }
    },
    redirect () {
      let smartdineLocalStorage = JSON.parse(window.localStorage.getItem('smartdine'))

      if (!this.isUserLoggedIn && !smartdineLocalStorage.token) this.$router.push({ name: 'Home' })
    }
  },
  computed: {
    ...mapGetters({
      isUserLoggedIn: 'isUserLoggedIn',
      user: 'user'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue